import dayjs from "dayjs";

// *Date Format for date picker
export const DateFormat = "MM-DD-YYYY"

// *Email Regex
export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

// *For Debounce
let debounceTimer;
export const Debounce = (func, delay = 1000) => {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(func, delay);
};

export const getDate = (date) => {
  if (!date) return
  const newDate = dayjs(date).format('MM-DD-YYYY')
  if (newDate === 'Invalid date') {
    return ''
  }
  return newDate
}

export const cleanObject = (obj) =>
  Object.fromEntries(
    Object.entries(obj).filter(
      ([, v]) => v !== null && v !== undefined
    )
  );
